import { render, staticRenderFns } from "./ElementPercentTableColumn.vue?vue&type=template&id=c230a0ba"
import script from "./ElementPercentTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementPercentTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports